<div
  #fullEl
  class="frm-galleria-fullscreen fixed top-0 left-0 w-full h-full bg-black-alpha-90"
  [style.opacity]="isFullShow ? 1 : 0"
  [style.visibility]="isFullShow ? 'visible' : 'hidden'"
  [style.transition]="
    isFullShow
      ? 'visibility 0s linear 0s, opacity ' + TIME_LOAD_IMAGE + 'ms'
      : 'visibility 0s linear ' + TIME_LOAD_IMAGE + 'ms, opacity ' + TIME_LOAD_IMAGE + 'ms'
  ">
  <div
    #toolboxElement
    class="frm-galleria-fullscreen__controls absolute flex gap-2 p-2 bg-black-alpha-90 border-round-2xl"
    style="top: 5px; right: 5px">
    <div
      class="frm-toolbar-button border-circle flex justify-content-center align-items-center h-3rem w-3rem cursor-pointer"
      (click)="rotateLeft()">
      <i
        class="pi pi-refresh text-white"
        style="font-size: 1.5rem"></i>
    </div>

    <div
      class="frm-toolbar-button border-circle flex justify-content-center align-items-center h-3rem w-3rem cursor-pointer"
      (click)="rotateRight()">
      <i
        class="pi pi-replay text-white"
        style="font-size: 1.5rem"></i>
    </div>

    <div
      class="frm-toolbar-button border-circle flex justify-content-center align-items-center h-3rem w-3rem cursor-pointer"
      (click)="scale > MIN_SCALE ? minusScale() : null">
      <i
        class="pi pi-search-minus"
        [class.text-white]="scale > MIN_SCALE"
        [class.text-gray-500]="scale <= MIN_SCALE"
        style="font-size: 1.5rem"></i>
    </div>

    <div
      class="frm-toolbar-button border-circle flex justify-content-center align-items-center h-3rem w-3rem cursor-pointer"
      (click)="scale < MAX_SCALE ? plusScale() : null">
      <i
        class="pi pi-search-plus"
        [class.text-white]="scale < MAX_SCALE"
        [class.text-gray-500]="scale >= MAX_SCALE"
        style="font-size: 1.5rem"></i>
    </div>

    <div
      class="frm-toolbar-button border-circle flex justify-content-center align-items-center h-3rem w-3rem cursor-pointer"
      (click)="onHideImage()">
      <i
        class="pi pi-times text-white"
        style="font-size: 1.5rem"></i>
    </div>
  </div>

  <div
    #backElement
    *ngIf="isShowBack"
    class="frm-galleria-fullscreen__controls absolute p-2 bg-black-alpha-90 border-round-2xl"
    style="left: 5px; top: calc(50vh - 24px)">
    <div
      class="frm-toolbar-button border-circle flex justify-content-center align-items-center h-3rem w-3rem cursor-pointer"
      (click)="backImage()">
      <i
        class="pi pi-angle-left text-white"
        style="font-size: 1.5rem"></i>
    </div>
  </div>

  <div
    #nextElement
    *ngIf="isShowNext"
    class="frm-galleria-fullscreen__controls absolute p-2 bg-black-alpha-90 border-round-2xl"
    style="right: 5px; top: calc(50vh - 24px)">
    <div
      class="frm-toolbar-button border-circle flex justify-content-center align-items-center h-3rem w-3rem cursor-pointer"
      (click)="nextImage()">
      <i
        class="pi pi-angle-right text-white"
        style="font-size: 1.5rem"></i>
    </div>
  </div>

  <div class="flex align-items-center justify-content-center h-full">
    <img
      #imageElement
      [src]="displayImages[activeImageIndex]?.src"
      [alt]="displayImages[activeImageIndex]?.alt"
      [style.transform]="'scale(' + scale + ') rotate(' + rotate + 'deg)'"
      [style.transition]="'transform 0.2s'"
      class="max-w-screen max-h-screen" />
  </div>
</div>
